import i18n from "@microdoing/shared/i18n";

const veryHardSmiley = require("../../assets/images/Emojis/VeryHard.png");
const hardSmiley = require("../../assets/images/Emojis/Hard.png");
const easySmiley = require("../../assets/images/Emojis/Easy.png");
const veryEasySmiley = require("../../assets/images/Emojis/VeryEasy.png");

export const feelingSmiley = {
  veryHard: veryHardSmiley,
  hard: hardSmiley,
  easy: easySmiley,
  veryEasy: veryEasySmiley,
};

export const getRate = donePercentage => {
  switch (donePercentage) {
    case 25:
      return {
        name: i18n.t(`feeling-text-veryHard`),
        smiley: feelingSmiley.veryHard,
      };
    case 50:
      return {
        name: i18n.t(`feeling-text-hard`),
        smiley: feelingSmiley.hard,
      };
    case 75:
      return {
        name: i18n.t(`feeling-text-easy`),
        smiley: feelingSmiley.easy,
      };
    case 100:
      return {
        name: i18n.t(`feeling-text-veryEasy`),
        smiley: feelingSmiley.veryEasy,
      };
    default:
      return {
        name: i18n.t(`feeling-text-easy`),
        smiley: feelingSmiley.easy,
      };
  }
};
